// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBkaNiDMB6qEccwnNBoBh0v7norbKv0V60",
  authDomain: "og-web-9a907.firebaseapp.com",
  projectId: "og-web-9a907",
  storageBucket: "og-web-9a907.appspot.com",   // <-- fixed here
  messagingSenderId: "30851541217",
  appId: "1:30851541217:web:56f95e126bc23d95d56fa0",
  measurementId: "G-R08MVT423B"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
